import React from "react";
import classNames from "classnames";
import styles from "./styles.scss";

const BulletedListItem: React.FC = ({ children }) => {
  return <li className={styles.BulletedList__li}>{children}</li>;
};

type BulletedListProps = {
  className?: string;
  children?: React.ReactNode;
};
const BulletedList = ({ children, className }: BulletedListProps) => {
  return <ul className={classNames(styles.BulletedList__ul, className)}>{children}</ul>;
};

export default BulletedList;

BulletedList.Item = BulletedListItem;
